import { Component, input, signal } from '@angular/core';
import { SidebarUserMenuTriggerComponent } from '@core/components/sidebar/components/user-menu/sidebar-user-menu-trigger.component';
import { SidebarUserMenuContentComponent } from '@core/components/sidebar/components/user-menu/sidebar-user-menu-content.component';
import { MenuTriggerComponent } from '@group24ag/flowkit';
import { SidebarComponent } from '@core/components/sidebar/sidebar.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-sidebar-user-menu',
  imports: [
    SidebarUserMenuTriggerComponent,
    SidebarUserMenuContentComponent,
    MenuTriggerComponent,
    NgClass,
  ],
  template: `
    <div class="relative">
      <div class="mx-1 border-t-2" [ngClass]="separatorColor"></div>

      <ng-template #userMenu>
        <app-sidebar-user-menu-content [width]="triggerWidth()" />
      </ng-template>

      <div #trigger flkMenuTrigger [triggerFor]="userMenu">
        <app-sidebar-user-menu-trigger
          [collapsed]="collapsed()"
          [menuOpen]="trigger.isOpen()" />
      </div>
    </div>
  `,
})
export class SidebarUserMenuComponent {
  /** INPUTS **/
  /****/
  readonly collapsed = input.required<boolean>();

  /****/
  protected readonly triggerWidth = signal<number>(
    SidebarComponent.SIDEBAR_EXPANDED_WIDTH - 1 - 2 * 8 // expanded sidebar width - border width - padding
  );

  protected get separatorColor() {
    return this.collapsed() ? 'border-transparent' : 'chrome--border';
  }
}
